import {
  Building2,
  Image,
  Images,
  LayoutDashboard,
  LayoutGrid,
  Newspaper,
  Network,
  ShieldCheck,
  Users,
  Map,
  Landmark,
  Contact,
  Layers,
  Megaphone,
  Quote as QuoteIcon,
  TrendingUp,
  Wrench,
  KeyRound,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export interface NavItem {
  label: string;
  to: string;
  icon: LucideIcon;
  permission: string;
}

export interface NavSection {
  title: string;
  items: NavItem[];
}

export const dashboardItem: NavItem = {
  label: 'Dashboard',
  to: '/',
  icon: LayoutDashboard,
  permission: 'dashboard:read',
};

export const navigation: NavSection[] = [
  {
    title: 'Content',
    items: [
      { label: 'Newsletter', to: '/newsletters', icon: Newspaper, permission: 'newsletter:read' },
      { label: 'Gallery', to: '/galleries', icon: Images, permission: 'gallery:read' },
      { label: 'Quotes', to: '/quotes', icon: QuoteIcon, permission: 'quote:read' },
      { label: 'Banners', to: '/banners', icon: Megaphone, permission: 'banner:read' },
    ],
  },
  {
    title: 'Master',
    items: [
      { label: 'Entities', to: '/entities', icon: Landmark, permission: 'entity:read' },
      { label: 'Assets', to: '/asset-opco', icon: Map, permission: 'asset:read' },
      { label: 'Facilities', to: '/facilities', icon: Wrench, permission: 'facility:read' },
      { label: 'Production', to: '/production', icon: TrendingUp, permission: 'production:read' },
      { label: 'Employee', to: '/employees', icon: Contact, permission: 'employee:read' },
      { label: 'Leadership Bands', to: '/leadership-groups', icon: Layers, permission: 'leadershipGroup:read' },
      {
        label: 'Employee Services',
        to: '/employee-services',
        icon: LayoutGrid,
        permission: 'employeeService:read',
      },
      { label: 'Organizations', to: '/organizations', icon: Building2, permission: 'organization:read' },
      { label: 'Stakeholder Tree', to: '/stakeholders', icon: Network, permission: 'stakeholder:read' },
    ],
  },
  {
    title: 'System',
    items: [
      { label: 'Media Library', to: '/media', icon: Image, permission: 'media:read' },
      { label: 'Users', to: '/users', icon: Users, permission: 'user:read' },
      { label: 'Access', to: '/access', icon: KeyRound, permission: 'role:read' },
      { label: 'Audit Log', to: '/audit-logs', icon: ShieldCheck, permission: 'audit:read' },
    ],
  },
];
